import React, { Component } from 'react';
import StripImage from './StripImage';

export default class MediaStrip extends Component {
    constructor(props) {
	super(props);
	this.state = {
	    parent: props.parent
	};
    }

    componentDidMount() {
	this.scroll();
    }

    componentDidUpdate() {
	this.scroll();
    }

    choose = mid => {
	this.state.parent.choose(mid);
	this.scroll();
    }

    scroll() {
	const chosen = document.getElementById('chosen')
	if (chosen) {
	    chosen.scrollIntoView({ behavior: "smooth", inline: "center" });
	}
    }

    render() {
	return (<div className="mediaStrip" id="mediaStrip">
		{this.props.media.map(m => <StripImage parent={this} media={m} chosen={m === this.props.chosen} scroll={this.scroll} key={m}/>)}
		</div>);
    }
}
